import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';

const ErrorService = {

	init() {
		axios.interceptors.response.use((response) => {
			return response;
		}, (error) => {

			console.log('error', error.response);

			if(error.response.data) {

				let errorMessage = '';
				let i = 0;

				if(typeof error.response.data === 'object' && error.response.data !== null) {
					for (var key in error.response.data) {
						if (Object.prototype.hasOwnProperty.call(error.response.data, key)) {
							for (i = 0; i < error.response.data[key].length; i++) {
								errorMessage += key + ': ' + error.response.data[key][i] + '<br>';
							}
						}
					}
				}

				// if(error.response.data.non_field_errors) {
				// 	for (let i = 0; i < error.response.data.non_field_errors.length; i++) {
				// 		errorMessage += error.response.data.non_field_errors[i] + '\n\r';
				// 	}
				// }

				Swal.fire(
					'Error',
					errorMessage,
					'error'
				)

				return Promise.reject(error);
			}
		});
	}
}

export default ErrorService;